import { Dispatch, SetStateAction } from "react";
import logo from "../assets/images/logo.png";
import { Link, useLocation } from "react-router-dom";

type IProps = {
  openMenu: boolean;
  setOpenMenu: Dispatch<SetStateAction<boolean>>;
};

export default function HeaderComponent({ openMenu, setOpenMenu }: IProps) {
  const { pathname } = useLocation();

  const navItems = [
    {
      label: "Home",
      link: "/",
    },
    {
      label: "Portal",
      link: "",
    },
    {
      label: "API",
      link: "",
    },
    {
      label: "Pricing",
      link: "",
    },
    {
      label: "Yaps",
      link: "",
    },
    {
      label: "Careers",
      link: "",
    },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 max-w-7xl mx-auto my-4 px-4">
      <div className="flex justify-between items-center bg-[#141414] px-4 py-3 rounded-2xl">
        <img src={logo} alt="logo" className="w-[200px]" />

        <div
          className="text-white 870:hidden block"
          onClick={() => setOpenMenu(!openMenu)}
        >
          {openMenu ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              className="lucide lucide-x w-6 h-6"
            >
              <path d="M18 6 6 18"></path>
              <path d="m6 6 12 12"></path>
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              className="lucide lucide-menu w-6 h-6"
            >
              <line x1="4" x2="20" y1="12" y2="12"></line>
              <line x1="4" x2="20" y1="6" y2="6"></line>
              <line x1="4" x2="20" y1="18" y2="18"></line>
            </svg>
          )}
        </div>

        {openMenu && (
          <div className="fixed left-0 right-0 top-[82px] z-40 bg-[rgba(0,0,0,01)] mx-4 rounded-xl">
            <div className="flex flex-col m-4 gap-2">
              {navItems.map((item, index) => (
                <Link
                  to=""
                  key={index}
                  className={`${
                    pathname === item.link ? "btn-primary" : "btn-secondary"
                  } ${
                    pathname === item.link ? "bg-[#FE0101]" : "transparent"
                  } funnel-display-semibold rounded-xl text-[#FCFCFC] text-sm py-2 px-4 transition-all duration-300 border borer-solid border-[#262626]`}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        )}

        <div className="hidden 870:flex items-center gap-3">
          {navItems.map((item, index) => (
            <Link
              to=""
              key={index}
              className={`${
                pathname === item.link ? "btn-primary" : "btn-secondary"
              } ${
                pathname === item.link ? "bg-[#FE0101]" : "transparent"
              } funnel-display-semibold rounded-xl text-[#FCFCFC] text-sm py-2 px-4 transition-all duration-300 border borer-solid border-[#262626]`}
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}
